<template>
    <div>
        <v-dialog v-model="display" persistent>          
            <v-card v-if="parameters != null" >
                <v-toolbar dense color="primary" dark>
                    <v-row align="center" dark>
                        <v-col cols="5" align="left">
                            <v-toolbar-title>Parametri aggiuntivi</v-toolbar-title>
                        </v-col>
                        <v-col cols="1" align="center">
                            <v-btn small light @click="save()">
                                <v-icon color="success">mdi-floppy</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="1" align="center">
                            <v-btn small light @click="addParameter()">
                                <v-icon color="primary">mdi-plus</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="5" align="right">
                            <v-btn small light @click="close">
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-toolbar>

                <v-container>
                    <v-expansion-panels>
                        <v-expansion-panel v-for="(parameter, i) in parameters" :key="i">

                            <v-expansion-panel-header>
                                <v-row no-gutters align="center" justify="start">
                                    <v-col align="left" cols="11">{{ parameter.name }}</v-col>
                                    <v-col cols="1">
                                        <v-btn small light @click="deleteParameter(parameter)">
                                            <v-icon color="error">mdi-delete</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <v-row align="center">
                                    <v-col cols="3">
                                        <v-text-field label="Nome" v-model="parameter.name" />
                                    </v-col>
                                    <v-col cols="3">
                                        <v-text-field label="Simbolo" v-model="parameter.symbol" />
                                    </v-col>
                                </v-row>
                                <v-row align="center">
                                    <v-col cols="3">
                                        <v-select v-model="parameter.access_type" label="Modalità accesso parametro" :items="access_types" @change="parameter.default_value = null" />
                                    </v-col>
                                    <v-col cols="3" align="center">
                                        <v-select v-model="parameter.type" label="Tipo parametro" :items="schema.data_types" @change="parameter.default_value = null" item-value="id_dato_quickconnext" item-text="nome" />
                                    </v-col>
                                    <v-col cols="3" align="center" v-if="parameter.type != null && parameter.access_type < 2">
                                        <DynamicInput v-model="parameter.default_value" :type="getDataTypeById(parameter.type).tipo" label="Valore Default" />
                                    </v-col>
                                </v-row>
                                <v-row v-if="isNumber(parameter) && parameter.access_type > 0">
                                    <v-col cols="3">
                                        <v-text-field type="number" v-model="parameter.boundaries.hard_min_value" label="Limite minimo valore" />
                                    </v-col>
                                    <v-col cols="3">
                                        <v-text-field type="number" v-model="parameter.boundaries.hard_max_value" label="Limite massimo valore" />
                                    </v-col>
                                    <v-col cols="3">
                                        <v-text-field type="number" v-model="parameter.boundaries.min_value" label="Valore minimo default" />
                                    </v-col>
                                    <v-col cols="3">
                                        <v-text-field type="number" v-model="parameter.boundaries.max_value" label="Valore massimo default" />
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import DynamicInput from '../.common/DynamicInput.vue';
export default {
    name:'DialogParametriRegistro',
    components : {
        DynamicInput
    },
    props : {
        access_types : Array,
        schema : Object
    },
    data(){
        return{
            display : false,
            parameters : null,
            register_reference : null
        }
    },
    methods : {
        //#region Common
        close(){
            Object.assign(this,{
                display : false,
                parameters : null,
                register_reference : null
            });
        },
        getDataTypeById(id){
            const data_types = this.schema.data_types;
            for(let i=0; i<data_types.length; i++){
                const data_type = data_types[i];
                if(data_type.id_dato_quickconnext == id){ return data_type; }
            }
            return new Object();
        },
        isNumber(item) {
            return this.getDataTypeById(item.type).tipo == 'number';
        },
        open(register_reference){
            this.register_reference = register_reference;
            this.parameters = JSON.parse(JSON.stringify(register_reference.parameters));
            this.display = true;
        },
        save(){
            this.register_reference.parameters = this.parameters;
            this.close();
        },
        //#endregion

        //#region Parametri
        addParameter() {
            let id = 1;
            const parameters = this.parameters;
            for (let i = 0; i < parameters.length; i++) {
                id = Math.max(Number(parameters[i].id), id) + 1;
            }
            parameters.push({
                symbol: null,
                name: "Parametro #" + id,
                default_value: null,
                type: null,
                id: id,
                access_type: 1,
                boundaries: {
                    min_value: null,
                    max_value: null,
                    hard_min_value: null,
                    hard_max_value: null
                },
            });
        },
        deleteParameter(parameter) {
            const parameters = this.parameters;
            parameters.splice(parameters.indexOf(parameter), 1);
        }
        //#endregion
    }
}
</script>